import { Project, ProjectType } from "../../models/Project";
import { calculateWorkingDays } from "../../utils/formatting";

// Re-export for backward compatibility
export { formatCurrency, formatDate } from "../../utils/formatting";

export const calculateEstimatedBudget = (project: Project): number | undefined => {
	if (project.type !== ProjectType.TimeAndMaterial || !project.dailyRate) {
		return undefined;
	}

	// Use workingDays if available (calculated field)
	if (project.workingDays && project.workingDays > 0) {
		return project.dailyRate * project.workingDays;
	}

	// Fallback calculation if workingDays is not available
	const totalDays = calculateWorkingDays(
		project.duration,
		project.durationType,
		project.fullTime,
		project.daysPerPeriod
	);

	return totalDays > 0 ? project.dailyRate * totalDays : undefined;
};
